/*
 *@description: 图片放大预览
 *@modifyContent:
 *@author: qiuhongyang
 *@date: 2021-05-18 17:25:25
 *
*/


/**
 *  图片放大预览
 *
 * @class PreViewPicture
 */
class PreViewPicture {
  Optios: any;
  constructor(opt: {
    imgboxdiv: string,
    imgclass: string,
    zindex?: number,
    scaleRate?:number
  }) {
    let defaultopt = {
      scaleRate:0.8,
      zindex:999,
      imgclass:"",
      imgboxdiv:""
    }
    this.Optios = $.extend({},defaultopt,opt);

    this.init();
  }

  init() {
    this.addOuterBox()
    this.bindEvent()
  }

  bindEvent() {
    let that = this;
    let opt = this.Optios;
    $(opt.imgboxdiv).on('click', opt.imgclass, function () {
      let _this = $(this);
      that.viewPicture(_this)
    })
  }

  viewPicture(_this: any) {
    let that = this;

    let src = _this.attr("src");

    if (!src) return false;

    $("#_preview_bigimg").attr("src", src);

    /*获取当前点击图片的真实大小，并显示弹出层及大图*/
    $("<img/>").attr("src", src).load(<any>function (this: any) {
      let windowW: any = $(window).width();
      let windowH: any = $(window).height();
      let realWidth = this.width;
      let realHeight = this.height;
      let imgWidth, imgHeight;
      let scale = that.Optios.scaleRate; //缩放尺寸，当图片真实宽度和高度大于窗口宽度和高度时进行缩放

      if (realHeight > windowH * scale) {//判断图片高度
        imgHeight = windowH * scale;//如大于窗口高度，图片高度进行缩放
        imgWidth = imgHeight / realHeight * realWidth;//等比例缩放宽度
        if (imgWidth > windowW * scale) {
          imgWidth = windowW * scale;//再对宽度进行缩放
        }
      }
      else if (realWidth > windowW * scale) {//如图片高度合适，判断图片宽度
        imgWidth = windowW * scale;//如大于窗口宽度，图片宽度进行缩放
        imgHeight = imgWidth / realWidth * realHeight;//等比例缩放高度
      }
      else {//如果图片真实高度和宽度都符合要求，高宽不变
        imgWidth = realWidth;
        imgHeight = realHeight;
      }

      $("#_preview_bigimg").css("width", imgWidth);//以最终的宽度对图片缩放

      let w = (windowW - imgWidth) / 2;
      let h = (windowH - imgHeight) / 2;

      $("#_preview_innerdiv").css({ "top": h, "left": w });//设置#innerdiv的top和left属性
      $("#_preview_outerdiv").fadeIn("fast");//淡入显示#outerdiv及.pimg
    });

    $("#_preview_outerdiv").click(function () {//再次点击淡出消失弹出层
      $(this).fadeOut("fast");
    });
  };

  addOuterBox() {
    let opt = this.Optios;

    let boxstr = `<div id="_preview_outerdiv" style="position:fixed;top:0;left:0;background:rgba(0,0,0,0.6);z-index:${opt.zindex};width:100%;height:100%;display:none;">
      <div id="_preview_innerdiv" style="position:absolute;">
        <img id="_preview_bigimg" src="" />
      </div>
    </div>`;

    $("body").append($(boxstr))
  }


};

export default PreViewPicture;